// apps/web/src/pages/login-page.tsx — Fase 01, Plano 35.
//
// Tela de login: card centralizado, densidade comfortable, único elemento
// sobre fundo neutro. Segue os tokens aprovados em 01-UI-SPEC.md (tema claro,
// espaçamentos, tipografia). Nenhum estado de sessão vive nesta página — a
// sessão é cookie HttpOnly da API (ADR-003).
import type { ReactElement } from 'react';
import { LoginForm } from '../components/auth/login-form';
import { AuthLayout } from '../components/auth/auth-layout';

export function LoginPage(): ReactElement {
  return (
    <AuthLayout>
        <p className="login-eyebrow">SEU ESPAÇO DE TRABALHO</p>
        <h1 className="login-page__title login-page__title--sr">Pieltec Gestão Industrial</h1>
        <h2 className="login-page__subtitle">Bem-vindo à Pieltec</h2>
        <p className="login-page__intro">Entre para acompanhar sua operação.</p>
        <LoginForm />
        <p className="mt-5 text-sm text-muted-foreground">Precisa de acesso ou ajuda para entrar? Contate o administrador da plataforma.</p>
    </AuthLayout>
  );
}
